import React, { useState } from 'react';
import { Box, Typography, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, Alert, Snackbar } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { format } from 'date-fns';

const labels24K = [
  '24K TOTAL Previous Balance',
  '24K Gold Received = 9999 =',
  '24K Jink =',
  '24K Galai Loss =',
  '24K Karigar chat =',
  '24K delivery Loss =',
  '24K Karigar Loss =',
  'EXTRA LOSS',
  'TOTAL 24K DELIVERY',
  'FINAL 24K TOTAL BALANCE',
];

const labels22K = [
  '22K TOTAL Previous Balance',
  '22K Gold Received = 916 =',
  '22K Jink =',
  '22K Galai Loss =',
  '22K Karigar chat =',
  '22K delivery Loss =',
  '22K Karigar Loss =',
  'EXTRA LOSS',
  'TOTAL 22K DELIVERY',
  'FINAL 22K TOTAL BALANCE',
];

const verticalLabels24K = ['24K Work:', '24/24K Work:', 'Wastage:', 'Total Weight:'];
const verticalLabels22K = ['22K Work:', '22/22K Work:', 'Wastage:', 'Total Weight:'];

const PreviousBalanceTable = ({ labels, verticalLabels, verticalValues, values, onChange, onVerticalChange }) => (
  <TableContainer component={Paper} sx={{ mb: 2, maxWidth: 900, mx: 'auto' }}>
    <Table size="small">
      <TableBody>
        {labels.map((label, idx) => (
          <TableRow key={label}>
            <TableCell sx={{ fontWeight: 600, width: 260 }}>{label}</TableCell>
            <TableCell>
              <TextField value={values[idx] || ''} onChange={e => onChange(idx, e.target.value)} size="small" variant="standard" fullWidth />
            </TableCell>
          </TableRow>
        ))}
        {/* Bottom row for vertical labels and inputs */}
        <TableRow>
          <TableCell colSpan={2} />
          {verticalLabels.map((vl, i) => (
            <TableCell key={vl} sx={{ width: 80, textAlign: 'center', verticalAlign: 'top', p: 0 }}>
              <TextField
                value={verticalValues && verticalValues['v'+i] ? verticalValues['v'+i] : ''}
                onChange={e => onVerticalChange && onVerticalChange('v'+i, e.target.value)}
                size="small"
                variant="standard"
                fullWidth
                sx={{ mb: 1 }}
              />
              <Typography
                sx={{
                  writingMode: 'vertical-rl',
                  transform: 'rotate(180deg)',
                  fontWeight: 600,
                  fontSize: 14,
                  color: 'primary.main',
                  mt: 1
                }}
              >
                {vl}
              </Typography>
            </TableCell>
          ))}
        </TableRow>
      </TableBody>
    </Table>
  </TableContainer>
);

const TransactionPreviousBalance = () => {
  const [values24K, setValues24K] = useState(Array(labels24K.length).fill(''));
  const [vertical24K, setVertical24K] = useState({ v0: '', v1: '', v2: '', v3: '' });
  const [values22K, setValues22K] = useState(Array(labels22K.length).fill(''));
  const [vertical22K, setVertical22K] = useState({ v0: '', v1: '', v2: '', v3: '' });
  const [saveSuccess, setSaveSuccess] = useState(false);
  const currentDate = new Date();

  const handleChange24K = (idx, value) => {
    setValues24K(vals => vals.map((v, i) => i === idx ? value : v));
  };
  const handleChange22K = (idx, value) => {
    setValues22K(vals => vals.map((v, i) => i === idx ? value : v));
  };
  const handleVertical24K = (key, value) => {
    setVertical24K(v => ({ ...v, [key]: value }));
  };
  const handleVertical22K = (key, value) => {
    setVertical22K(v => ({ ...v, [key]: value }));
  };
  const handleSave = () => {
    setSaveSuccess(true);
  };

  return (
    <Box sx={{ mt: 8, px: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <Button startIcon={<ArrowBackIcon />} onClick={() => window.history.back()} variant="outlined" color="primary" sx={{ mr: 2 }}>
          Back
        </Button>
        <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
          <Typography variant="h6" sx={{ textAlign: 'right' }}>
            Date: {format(currentDate, 'dd/MM/yyyy')}
          </Typography>
        </Box>
      </Box>
      <Typography variant="h5" sx={{ mb: 2, textAlign: 'center', fontWeight: 600 }}>24K Gold</Typography>
      <PreviousBalanceTable labels={labels24K} verticalLabels={verticalLabels24K} verticalValues={vertical24K} values={values24K} onChange={handleChange24K} onVerticalChange={handleVertical24K} />
      <Typography variant="h5" sx={{ mb: 2, textAlign: 'center', fontWeight: 600 }}>22K Gold</Typography>
      <PreviousBalanceTable labels={labels22K} verticalLabels={verticalLabels22K} verticalValues={vertical22K} values={values22K} onChange={handleChange22K} onVerticalChange={handleVertical22K} />
      <Box sx={{ mt: 2, textAlign: 'right' }}>
        <Button variant="contained" color="primary" onClick={handleSave}>
          Save Transaction
        </Button>
      </Box>
      <Snackbar open={saveSuccess} autoHideDuration={3000} onClose={() => setSaveSuccess(false)} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert onClose={() => setSaveSuccess(false)} severity="success" sx={{ width: '100%' }}>
          Transaction saved successfully!
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default TransactionPreviousBalance; 